import { render, staticRenderFns } from "./actionsPanel.vue?vue&type=template&id=588b72e4&scoped=true"
import script from "./actionsPanel.vue?vue&type=script&lang=js"
export * from "./actionsPanel.vue?vue&type=script&lang=js"
import style0 from "./actionsPanel.vue?vue&type=style&index=0&id=588b72e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b72e4",
  null
  
)

export default component.exports